import { render, staticRenderFns } from "./MenuCheck.vue?vue&type=template&id=1d870af2&scoped=true&"
import script from "./MenuCheck.vue?vue&type=script&lang=js&"
export * from "./MenuCheck.vue?vue&type=script&lang=js&"
import style0 from "./MenuCheck.vue?vue&type=style&index=0&id=1d870af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d870af2",
  null
  
)

export default component.exports